import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { enableMapSet } from 'immer'
enableMapSet()

import * as Sentry from '@sentry/react'

if (import.meta.env.MODE === 'production') {
  Sentry.init({
    dsn: 'https://9889b7d710211eb023ce10155bec2fcf@o4509214016012288.ingest.de.sentry.io/4509214026498128',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
